import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <h1>Le Petit Secret</h1>
        <hr/>
        <h4>Pardon Our Dust</h4>
        <p>Website Under Construction</p>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js